<template>
   <div class='parent-wrapper'>
      <atom-select
         :value="hcValue"
         :options="options"
         ref='select'
         @input='val => hcValue=val'
         :color="color"
         :size="size"
      />
      <div class="text-input">
         <atom-input
            :type="type"
            :placeholder="placeholder"
            v-bind="$props"
            class='input'
            :class="classes"
            v-model="hcValue"
         />
      </div>
   </div>
</template>

<script>
import SelectInput from '@/components/atoms/Home/SelectInput';
import Input from '@/components/atoms/Login/Input';

export default {
   name: 'editable-select-input',
   components: {
      'atom-select': SelectInput,
      'atom-input': Input,
   },
   props: {
      type: {
         type: String,
         default: 'text',
         validator: value => ['text', 'email', 'number', 'textarea', 'password'].includes(value),
      },
      options: {
         type: Array,
         required: true,
      },
      value: {
         required: true,
         validator: value => (
            value==null ||
            typeof(value) === "string" ||
            typeof(value) === "number"
         ),
      },
      placeholder: {
         type: String,
      },
      color: {
         type: String,
         default: 'primary',
         validator: value => ['primary', 'success', 'info', 'danger'].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => ["large", "medium", "small"].includes(value),
      },
   },
   computed: {
      hcValue: {
         get()
         {
            return this.value;
         },
         set(newValue, oldValue)
         {
            if (newValue!==oldValue) this.$emit('input', newValue);
         }
      },
      classes()
      {
         return [this.color, this.size];
      }
   },
};
</script>

<style lang="scss" scoped>
.parent-wrapper {
   position: relative;
   .text-input {
      position: absolute;
      top: -1px;
      left: 5px;
      right: 15px;
      bottom: 0;
      > * {
         border: none;
         background: transparent;
         &:focus {
            border: none;
            box-shadow: none;
         }
      }
   }
}

</style>
